var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup514(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.345,
    height: 25.573,
    viewBox: "0 0 28.345 25.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 21.589,
    height: 17.384,
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(-1262.55 -526.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(1262.55 526.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M18.52,2.743h-8.1a.291.291,0,0,1-.22-.105L8.647.716A1.96,1.96,0,0,0,7.12,0H3.084A3.077,3.077,0,0,0,0,3.084V14.3a3.077,3.077,0,0,0,3.084,3.084H18.505A3.077,3.077,0,0,0,21.589,14.3V5.828a3.094,3.094,0,0,0-.9-2.178,3.037,3.037,0,0,0-2.168-.906m1.4,11.566a1.4,1.4,0,0,1-1.4,1.4H3.1a1.39,1.39,0,0,1-.991-.411,1.419,1.419,0,0,1-.411-.991V3.084a1.4,1.4,0,0,1,1.4-1.4H7.125a.291.291,0,0,1,.22.105L8.9,3.71a1.955,1.955,0,0,0,1.527.726h8.1a1.4,1.4,0,0,1,1.4,1.4Z",
    transform: "translate(0 0)",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(1276.007 537.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M330.99,260.28a7.444,7.444,0,1,1-7.444-7.444,7.444,7.444,0,0,1,7.444,7.444",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M398.211,327.024h-2.555v-2.615a.617.617,0,0,0-1.233,0v2.615h-2.555a.617.617,0,1,0,0,1.233h2.555v2.494a.617.617,0,1,0,1.233,0v-2.494h2.555a.617.617,0,0,0,0-1.233",
    transform: "translate(-387.391 -320.146)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup514);
export default __webpack_public_path__ + "static/media/Group 514.500824d37e7c23c2544384e251d25d23.svg";
export { ForwardRef as ReactComponent };